module.exports = __webpack_public_path__ + "img/support-bkg.3168d574.png";